module.exports = __webpack_public_path__ + "img/arrow_down.919f3768.svg";